var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _vm.totalElements
        ? _c(
            "div",
            { staticClass: "as-order-wrap" },
            _vm._l(_vm.asMsgList, function(item) {
              return _c(
                "div",
                { key: item.id },
                [
                  _c("asOrderItem", {
                    attrs: { item: item },
                    on: { closeDialog: _vm.closeDialog }
                  })
                ],
                1
              )
            }),
            0
          )
        : _c(
            "div",
            {
              staticStyle: { "text-align": "center", color: "rgba(0,0,0,0.65)" }
            },
            [_vm._v("\n    暂无数据\n  ")]
          ),
      _vm._v(" "),
      _vm.totalElements
        ? _c("el-pagination", {
            attrs: {
              "page-size": _vm.size,
              "current-page": _vm.page,
              "page-sizes": [10, 20, 50, 100],
              "pager-count": 11,
              layout: "total, sizes, prev, pager, next",
              total: _vm.totalElements
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9bc26b98", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bc26b98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pendingOrder/asOrder.vue
// module id = null
// module chunks = 